import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import Avatar from '@material-ui/core/Avatar';
import Chip from '@material-ui/core/Chip';
import grey from '@material-ui/core/colors/grey';
import Icon from '@material-ui/core/Icon';

const styleSheet = theme => ({
  chip: {
    margin: theme.spacing.unit
  },
  svgIcon: {
    color: grey[800]
  },
  row: {
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap'
  }
});

class Chips extends Component {
  static propTypes = {
    classes: PropTypes.shape({}).isRequired,
    list: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired
      })
    ).isRequired,
    onRemove: PropTypes.func.isRequired
  }

  getIcon = type => {
    switch (type) {
      case 'mediaId':
        return 'play_circle_outline';
      case 'driver':
        return 'person';
      case 'vehicle':
        return 'local_shipping';
      case 'dvr':
        return 'dvr';
      default:
        return '';
    }
  }

  render() {
    const {classes, list, onRemove, ...other} = this.props;

    return (
      <div className={classes.row}>
        {
          list.map((chip, index) => (
            <Chip
              key={index} // eslint-disable-line react/no-array-index-key
              avatar={
                <Avatar className="chip">
                  <Icon className="chip__icon">{this.getIcon(chip.name)}</Icon>
                </Avatar>
              }
              label={chip.label}
              onDelete={event => onRemove(event, chip)}
              className={classes.chip}
              {...other}
            />))
        }
      </div>
    );
  }
}

export default withStyles(styleSheet)(Chips);
